import React from 'react';
import { Link } from 'react-router-dom';
import { type IMerchant } from '../../models/IMerchant';
import styles from './index.module.css';

interface IProps {
	merchant: IMerchant;
}

export const MerchantCard = ({merchant}: IProps) => {
	return (
		<Link className={styles.card} key={ merchant.id } to={`/merchant/${merchant.id}`}>
			<img src={ merchant.logo_url} alt="logo" className={styles.card_logo}/>
			<p className={styles.card_name}>{merchant.name}</p>
		</Link>
	);
};
